import React, { useEffect, useState } from 'react';
import { ButtonSecondary } from '@spotify-internal/encore-web';

export function SubmitDraftButton(props: {
  isSubmitting: boolean;
  isPublished?: boolean;
  pristine: boolean;
  onClick: (e: React.FormEvent) => void;
}) {
  const { isPublished, pristine, isSubmitting, onClick } = props;
  const [isActive, setIsActive] = useState(false);
  function getText() {
    if (isActive && isSubmitting) {
      return isPublished ? 'Reverting...' : 'Saving...';
    }
    return isPublished ? 'Revert to draft' : 'Save as draft';
  }

  useEffect(() => {
    if (!isSubmitting && !isPublished) {
      setIsActive(false);
    }
  }, [isPublished, isSubmitting]);

  return (
    <ButtonSecondary
      disabled={isSubmitting || (pristine && !isPublished)}
      onClick={e => {
        setIsActive(true);
        onClick(e);
      }}
    >
      {getText()}
    </ButtonSecondary>
  );
}
